<template>
  <div>
    <el-button @click="handleProceed" v-if="store.step < store.config.steps">
      {{ text || 'Proceed' }} 
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { ElNotification } from 'element-plus';
import { useDonationFormsStore } from '../store';
import { watch } from 'vue';

const store = useDonationFormsStore();
const props = defineProps({
  text: String,
  show_min_max_donation: Boolean,
  max_donation_amount: Number,
  min_donation_amount: Number,
  post_type: String,
  campaign_ended: {
    type: Boolean,
    default: false
  },
  error_message: {
    type: String,
    default: 'Target has been achieved'
  }
});

const validateAmount = (val) => {
  if (props.show_min_max_donation) {
    if (['cause', 'wp_commerce_forms'].includes(props.post_type)) {
      if (val > props.max_donation_amount) {
        // store.amount = props.max_donation_amount;
        ElNotification({
          title: 'Error',
          message: `Amount should be less than ${props.max_donation_amount}`,
          type: 'error',
          duration: 5000,
          showClose: true
        });
        return false;
      }
      if (val < props.min_donation_amount) {
        // store.amount = props.min_donation_amount;
        ElNotification({
          title: 'Error',
          message: `Amount should be greater than ${props.min_donation_amount}`,
          type: 'error',
          duration: 5000,
          showClose: true
        });

        return false;
      }
    }
  }
  return true;
};

const handleProceed = () => {

  if (!validateAmount(store.amount)) {
    return;
  }
  if (props.campaign_ended) {
    ElNotification({
      'title' : 'Error',
      message: props.error_message,
      type: 'error',
      duration: 5000,
      showClose: true
    });
  } else {
    store.step++;
  }
};

watch(() => props.campaign_ended, (newVal) => {
  if (newVal) {
    ElNotification({
      message: props.error_message,
      type: 'error',
      duration: 5000,
      showClose: true
    });
  }
});

</script>